// extracted by mini-css-extract-plugin
export default {"header":"ActiveGiftCardTable_header__fza8u","header-title":"ActiveGiftCardTable_header-title__tVppE"};